<div
  class="p-4 rounded flex justify-start items-center gap-2"
  [class]="{
    'bg-red-100': type() === AlertTypeEnum.ERROR,
    'border-red-400': type() === AlertTypeEnum.ERROR,
  }"
>
  @if (type() === AlertTypeEnum.ERROR) {
    <app-icon
      path="./assets/icons/warning-circle.svg"
      color="#dc2626"
    />
  } @else if (type() === AlertTypeEnum.SUCESS) {
    <app-icon
      path="./assets/icons/check-circle.svg"
      color="#dc2626"
    />
  } @else {
    <app-icon path="" />
  }
  <span class="text-red-600 text-sm">{{ message() }}</span>
</div>
